import {DataTableGlobalFilter} from '@/components/data-table/data-table-global-filter';
import {DataTableToolbarProps} from '@/components/data-table/data-table-toolbar';
import {CreateButton, RefreshButton} from '../action_buttons';
import {DataTableViewOptions} from '@/components/data-table/data-table-view-options';
import {ReactNode} from 'react';
import {
  BulkActionItemType,
  DataTableBulkActions,
} from '@/components/data-table/data-table-bulk-actions';

interface NewDataTableToolbarProps extends DataTableToolbarProps {
  resource?: string;  
  createButton?: boolean | ReactNode;
  refreshButton?: boolean;
  viewOptions?: boolean;
  viewOptionsStorageKey?: string;
  globalFilter?: boolean;
  filters?: ReactNode;
  bulkActions?: BulkActionItemType[];
}

const DefaultDataTableToolbar = (props: NewDataTableToolbarProps) => {
  const {
    resource,
    createButton = true,
    refreshButton = false,
    viewOptions = true,
    globalFilter = true,
    filters,
    bulkActions,
    table: tanstackTable,
    viewOptionsStorageKey,
  } = props;

  return (
    <div className="flex items-center space-x-2">
      {createButton === true ? <CreateButton resource={resource} /> : createButton}
      {viewOptions && (
        <DataTableViewOptions
          table={tanstackTable}
          storageKey={viewOptionsStorageKey}
        />
      )}
      {bulkActions && <DataTableBulkActions table={tanstackTable} actions={bulkActions} />}
      {refreshButton && <RefreshButton />}
      <div className="flex-grow" />
      {filters}
      {globalFilter && (
        <div className="w-64">
          <DataTableGlobalFilter table={tanstackTable} />
        </div>
      )}
    </div>
  );
};

export default DefaultDataTableToolbar;
